<template>
  <v-card>
    <v-card-text>
      <h3 class="my-2 primary--text font-weight-light">Filtrar Resultados</h3>
      <v-autocomplete
        no-data-text="No hay Servicios Registrados"
        label="Por Servicio"
        :items="services"
        v-model="service"
        clearable
        @change="$emit('service', service)"
      ></v-autocomplete>
      <v-select
        label="Por Estado"
        :items="statuses"
        item-text="status"
        item-value="value"
        v-model="status"
        clearable
        @change="$emit('status', status)"
      ></v-select>
      <v-menu
        v-model="menuDateFrom"
        :close-on-content-click="false"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dateFrom"
            label="Fecha desde"
            prepend-icon="event"
            readonly
            clearable
            v-on="on"
            @change="$emit('dateFrom', dateFrom)"
          ></v-text-field>
        </template>
        <v-date-picker
          no-title
          v-model="dateFrom"
          @input="menuDateFrom = false"
        ></v-date-picker>
      </v-menu>
      <v-menu
        v-model="menuDateTo"
        :close-on-content-click="false"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dateTo"
            label="Fecha hasta"
            prepend-icon="event"
            readonly
            clearable
            v-on="on"
            @change="$emit('dateTo', dateTo)"
          ></v-text-field>
        </template>
        <v-date-picker
          no-title
          v-model="dateTo"
          @input="menuDateTo = false"
        ></v-date-picker>
      </v-menu>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    statuses: {
      type: Array,
      default: () => []
    },
    services: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      status: null, 
      service: null,
      dateFrom: null,
      menuDateFrom: false,
      dateTo: null,
      menuDateTo: false
    }
  }
}
</script>